import { IMessageTemplate } from '@clickersphere/core/entities/IMessageTemplate';
import { Button } from '../../Button';
import { Input } from '../../Input';
import { Textarea } from '../../Textarea';
import { useMessageTemplateModalController } from './useMessageTemplateModalController';

interface IMessageTemplateModalProps {
  messageTemplate?: IMessageTemplate;
}

export default function MessageTemplateModal({
  messageTemplate,
}: IMessageTemplateModalProps) {
  const {
    t,
    register,
    errors,
    bodyField,
    assignBodyRef,
    variables,
    handleInsertVariable,
    handleSubmit,
    handleClose,
    isPending,
  } = useMessageTemplateModalController(messageTemplate);

  return (
    <form className="my-4 flex w-full flex-col gap-4" onSubmit={handleSubmit}>
      <Input
        type="text"
        placeholder={t('settings.messageTemplates.modal.fields.name')}
        {...register('name')}
        error={errors.name?.message}
        disabled={isPending}
      />

      <Textarea
        placeholder={t('settings.messageTemplates.modal.fields.body')}
        {...bodyField}
        ref={assignBodyRef}
        error={errors.body?.message}
        disabled={isPending}
        className="min-h-40"
      />

      <div className="flex flex-col gap-2">
        <span className="text-text-tertiary text-xs">
          {t('settings.messageTemplates.modal.variablesHint')}
        </span>
        <div className="flex flex-wrap gap-2">
          {variables.map((variable) => (
            <button
              key={variable}
              type="button"
              disabled={isPending}
              onClick={() => handleInsertVariable(variable)}
              className="bg-hover-subtle text-text-secondary hover:bg-hover-medium rounded px-2 py-1 text-xs transition-colors disabled:opacity-50"
            >
              {`{{${variable}}}`}
            </button>
          ))}
        </div>
      </div>

      <section className="mt-2 flex w-full gap-4">
        <Button
          className="w-40"
          color="ghost"
          labelPath="settings.messageTemplates.modal.cancel"
          disabled={isPending}
          onClick={handleClose}
        />
        <Button
          type="submit"
          labelPath="settings.messageTemplates.modal.submit"
          isLoading={isPending}
          disabled={isPending}
        />
      </section>
    </form>
  );
}
